export default __webpack_public_path__ + "static/media/March2017.67416ab6.png";